import {
  ActionIcon,
  Box,
  Button,
  ComboboxItem,
  Divider,
  Fieldset,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  NumberInput,
  Select,
  Stack,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCaretLeft,
  IconCaretRight,
  IconCheck,
  IconCirclePlus,
  IconWindow,
} from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  getItemFromData,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getTblDmCustomerGroupSelect,
  getTblDmEmployeeAll,
} from "../../../service/getSelectApi";
import axios from "axios";

interface nameAddress {
  provinceName: string;
  communeName: string;
}

const newGuid = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function")
    return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const EditDataView = ({
  id,
  onClose,
  isCreateBySeller = false,
  setCustomerCheck,
}: EditDataViewProps) => {
  const entity = {
    id: 0,
    code: null,
    name: null,
    email: null,
    active: false,
    address: null,
    birthOfDate: null,
    contact: null,
    description: null,
    fax: null,
    parentId: null,
    sex: null,
    taxCode: null,
    telephoneNumber: null,
    type: null,
    groupId: null,
    groupName: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
    listInfoCustomers: [
      {
        stt: 1,
        name: null,
        sex: null,
        birthOfDate: null,
        telephoneNumber: null,
        attribute1: null, //đây là biến lưu email của mỗi người mua hàng khi kh là doanh nghiệp
        attribute2: null,
        attribute3: null,
      },
    ],
    listInfoAddress: [
      {
        stt: 1,
        province: null,
        district: null,
        commune: null,
        address: null,
        attribute1: null, //nếu có 1 địa chỉ thì sẽ là địa chỉ xuất hóa đơn , nếu lớn hơn 2 thì cái thứ 2  trở đi sẽ là địa chỉ giao hàng
        attribute2: null,
        attribute3: null,
      },
    ],
  };

  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const [visible, { close, open }] = useDisclosure(false);
  const [dataTblCustomerGroup, setDataTblCustomerGroup] = useState<
    { value: string; label: string; att1: string }[]
  >([]);
  const [dataEmployeeHacom, setDataEmployeeHacom] = useState<any[]>([]);
  const [dataTblProvince, setDataTblProvince] = useState<ComboboxItem[]>([]);
  const [dataTblCommune, setDataTblCommune] = useState<ComboboxItem[]>([]);
  const [dataTblDebtGroup, setDataTblDebtGroup] = useState<ComboboxItem[]>([]);
  const [isChangeDebt, setIsChangeDebt] = useState(false);
  const [dataDebt, setDataDebt] = useState<any[]>([]);
  const [listInfoAddressText, setListInfoAddressText] = useState<nameAddress>({
    provinceName: "",
    communeName: "",
  });
  const [addressCurrentVAT, setAddressCurrentVAT] = useState<string>("");
  const [nameCommune, setNameCommune] = useState<string>("");

  const [keySearchDebt, setKeySearchDebt] = useDebouncedState("", 500);

  const form = useForm<any>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
      listInfoAddress: entity.listInfoAddress || [], // Đảm bảo luôn là mảng
      listInfoCustomers: entity.listInfoCustomers || [], // Đảm bảo luôn là mảng
    },

    validate: {
      code: (value: string | null) => {
        if (form.getValues().type?.toString() === "3" && !value) {
          return "Vui lòng nhập mã khách hàng !";
        }
      },
      type: (value: string | null) => {
        if (!value) {
          return "Vui lòng chọn loại khách hàng !";
        }
      },
      attribute13: (value: string | null) => {
        const { type } = form.getValues();

        if (!value && (String(type) === "1" || String(type) === "4")) {
          return "Vui lòng chọn Tỉnh/Thành phố !";
        }
        return null;
      },
      attribute14: (value: string | null) => {
        const { type } = form.getValues();

        if (!value && (String(type) === "1" || String(type) === "4")) {
          return "Vui lòng chọn Phường/Xã !";
        }
        return null;
      },
      address: (value: string | null) => {
        const { type } = form.getValues();
        if (!value && (String(type) === "1" || String(type) === "4")) {
          return "Vui lòng nhập địa chỉ cụ thể !";
        }
        return null;
      },

      groupId: (value: string | null) => {
        if (form.getValues().type?.toString() !== "2" && !value) {
          return "Vui lòng chọn nhóm khách hàng !";
        }
        return null;
      },
      attribute1: (value: string | null) => {
        if (!value) {
          return "Vui lòng chọn đối tượng công nợ !";
        }
        return null;
      },
      companyName: (value: string | null) => {
        if (
          form.getValues().type?.toString() !== "1" &&
          form.getValues().type?.toString() !== "4" &&
          !value
        ) {
          return "Vui lòng nhập tên doanh nghiệp !";
        }
        return null;
      },
      taxCode: (value: string | null) => {
        if (
          form.getValues().type?.toString() !== "1" &&
          form.getValues().type?.toString() !== "4" &&
          form.getValues().groupId?.toString() !== "204" &&
          !value
        ) {
          return "Vui lòng nhập mã số thuế !";
        }
        return null;
      },
      name: (value: any | null) => {
        if (
          (form.getValues().type?.toString() == "1" ||
            form.getValues().type?.toString() == "4") &&
          !value
        ) {
          return "Vui lòng nhập tên khách hàng !";
        }
        if (
          (form.getValues().type?.toString() == "1" ||
            form.getValues().type?.toString() == "4") &&
          value.length > 50
        ) {
          return "Tên khách hàng không được dài hơn 50 ký tự !";
        }
        return null;
      },

      attribute2: (value: string | null) => {
        if (form.getValues().type?.toString() === "3" && !value) {
          return "Vui lòng nhập thời hạn công nợ !";
        }
        return null;
      },
      debtLimit: (value: string | null) => {
        if (form.getValues().type?.toString() === "3" && !value) {
          return "Vui lòng nhập hạn mức công nợ !";
        }
        return null;
      },
      listInfoCustomers: {
        name: (value: string | null) => {
          if (
            form.getValues().type?.toString() !== "1" &&
            form.getValues().type?.toString() !== "4" &&
            !value
          ) {
            return "Vui lòng nhập họ và tên !";
          }
          return null;
        },
        telephoneNumber: (value: string | null) => {
          if (
            form.getValues().type?.toString() !== "1" &&
            form.getValues().type?.toString() !== "4" &&
            value &&
            !/^\d{8,11}$/.test(value)
          ) {
            return "Số điện thoại phải có từ 8 đến 11 chữ số!";
          }
          if (
            form.getValues().type?.toString() !== "1" &&
            form.getValues().type?.toString() !== "4" &&
            !value
          ) {
            return "Vui lòng nhập số điện thoại !";
          }
          return null;
        },
      },
      listInfoAddress: {
        province: (value: string | null) => {
          if (
            form.getValues().type?.toString() !== "1" &&
            form.getValues().type?.toString() !== "4" &&
            !value
          ) {
            return "Vui lòng chọn Tỉnh/Thành phố !";
          }
        },
        commune: (value: string | null) => {
          if (
            form.getValues().type?.toString() !== "1" &&
            form.getValues().type?.toString() !== "4" &&
            !value
          ) {
            return "Vui lòng chọn Phường/Xã !";
          }
        },
        address: (value: string | null) => {
          if (
            form.getValues().type?.toString() !== "1" &&
            form.getValues().type?.toString() !== "4" &&
            !value
          ) {
            return "Vui lòng nhập địa chỉ cụ thể !";
          }
          return null;
        },
      },
    },
  });

  //thực hiện cho màn edit với doanh nghiệp
  const [currentIndexKH, setcurrentIndexKH] = useState(0); //cho màn KH
  const [currentIndexKHDC, setcurrentIndexKHDC] = useState(0); //cho màn KH
  const nextCustomer = (type: number, index?: number) => {
    if (type === 1) {
      if (index !== undefined) {
        setcurrentIndexKH(index - 1); // Chuyển đến người mới nhất
      } else if (
        currentIndexKH <
        form.getValues().listInfoCustomers.length - 1
      ) {
        setcurrentIndexKH(currentIndexKH + 1);
      }
    } else {
      if (index !== undefined) {
        setcurrentIndexKHDC(index - 1); // Chuyển đến địa chỉ mới nhất
      } else if (
        currentIndexKHDC <
        form.getValues().listInfoAddress.length - 1
      ) {
        setcurrentIndexKHDC(currentIndexKHDC + 1);
      }
    }
  };

  const prevCustomer = (type: number) => {
    if (type === 1) {
      if (currentIndexKH > 0) {
        setcurrentIndexKH(currentIndexKH - 1);
      }
    } else {
      if (currentIndexKHDC > 0) {
        setcurrentIndexKHDC(currentIndexKHDC - 1);
      }
    }
  };

  const callApiGetData = async () => {
    open();
    await Promise.all([dataCustomerGroupSelect(), dataProvinceSelect()]);
    const callApi = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/TblDmCustomer/edit?Id=${id}`,
    );
    if (callApi?.success) {
      const dataApi = callApi?.data;

      if (dataApi !== null) {
        await fetchDataDebt(dataApi?.attribute1);
        setAddressCurrentVAT(dataApi?.attribute16 || "");

        form.setValues({
          ...dataApi,
          listInfoAddress:
            dataApi?.listInfoAddress &&
            String(dataApi?.listInfoAddress).length > 0 &&
            dataApi?.listInfoAddress !== "[]"
              ? Array.isArray(JSON.parse(dataApi?.listInfoAddress || "[]"))
                ? JSON.parse(dataApi?.listInfoAddress || "[]")
                : [JSON.parse(dataApi?.listInfoAddress || "{}")]
              : Array.isArray(JSON.parse(dataApi?.attribute11 || "[]"))
                ? JSON.parse(dataApi?.attribute11 || "[]")
                : [JSON.parse(dataApi?.attribute11 || "{}")],

          listInfoCustomers: Array.isArray(
            JSON.parse(dataApi?.listInfoCustomers || "[]"),
          )
            ? JSON.parse(dataApi?.listInfoCustomers || "[]")
            : [JSON.parse(dataApi?.listInfoCustomers || "{}")],
        });
        form.resetDirty(dataApi);

        if (String(dataApi.type) === "4") {
          fetchDataEmployeeHacom();
        }

        setTimeout(() => {
          setIsCallFirst(true);
        }, 1000);
      }
      close();
    }
  };

  const dataCustomerGroupSelect = async () => {
    try {
      const getData = await getTblDmCustomerGroupSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
        att1: item.att1,
      }));
      setDataTblCustomerGroup(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const dataProvinceSelect = async () => {
    try {
      const getData = await repositoryMdm.get(
        "/api/v1/TblDmProvinceMoi/get-list?Active=true&Skip=0&Take=500",
      );
      const filteredData = getData?.data?.filter(
        (item: any) => item.id != null && item.name != null,
      );
      const mappedData = filteredData?.map((item: any) => ({
        value: String(item.id),
        label: item.name,
      }));
      setDataTblProvince(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const dataCommuneSelect = async (idProvince: string, communeTax?: string) => {
    if (!communeTax) {
      try {
        const getData = await repositoryMdm.get(
          `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${idProvince}`,
        );
        const filteredData = getData?.data?.filter(
          (item: any) => item.value != null && item.text != null,
        );
        const mappedData = filteredData?.map((item: any) => ({
          value: item.value,
          label: item.text,
        }));
        setDataTblCommune(mappedData);
      } catch (error) {
        console.error("Error in dataTblLocation: ", error);
      }
    } else {
      try {
        const getData = await repositoryMdm.get(
          `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${idProvince}`,
        );
        const filteredData = getData?.data
          ?.filter((item: any) => item.value != null && item.text != null)
          ?.find((i: any) => String(i.text).toLowerCase().includes(communeTax));

        return filteredData;
      } catch (error) {
        console.error("Error in dataTblLocation: ", error);
      }
    }
  };

  const fetchDataDebt = async (value?: string) => {
    let url = `/api/v1/TblDebtGroup/get-list?Skip=0&Take=25&KeySearch=${
      value ?? keySearchDebt
    }`;

    try {
      const response = await repositoryPos.get<MessageResponse<any[]>>(url);
      if (response?.success && response?.data) {
        const data = response.data;
        setDataDebt(data);

        const mappedData = Array.from(
          new Map(
            data.map((value) => [
              value?.groupCode,
              {
                value: value?.groupCode?.toString(),
                label: `${value?.groupCode?.toString()} - ${value?.groupName}`,
              },
            ]),
          ).values(),
        );
        setDataTblDebtGroup(mappedData);
      }
    } catch (error) {
      setDataTblDebtGroup([]);
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataEmployeeHacom = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      setDataEmployeeHacom(res.filter((i) => i.code && i.fullname));
    }
  };

  useEffect(() => {
    if (keySearchDebt) {
      fetchDataDebt();
    }
  }, [keySearchDebt]);

  const handleEditTblDMCustomer = async (dataSubmit: any) => {
    switch (form.getValues().type?.toString()) {
      case "1":
        dataSubmit = {
          ...dataSubmit,
          companyName: null,
          taxCode: null,
        };
        break;
      case "2":
        dataSubmit = { ...dataSubmit, groupId: 142 };
        break;
      case "3":
        dataSubmit = { ...dataSubmit };
        break;
    }

    const isType1 = String(form.getValues().type) !== "1";
    const isType4 = String(form.getValues().type) !== "4";

    // Xử lý attribute1 cho listInfoAddress
    if (isType1 && isType4 && dataSubmit.listInfoAddress?.length === 1) {
      dataSubmit.listInfoAddress[0].attribute1 = "BILL_TO_SHIP_TO";
    } else if (isType1 && isType4 && dataSubmit.listInfoAddress?.length > 1) {
      dataSubmit.listInfoAddress.forEach((item: any, index: number) => {
        item.attribute1 = index === 0 ? "BILL_TO" : "SHIP_TO";
      });
    }

    if (
      String(form.getValues().type) !== "1" &&
      String(form.getValues().type) !== "4" &&
      addressCurrentVAT.length === 0
    ) {
      NotificationExtension.Fails("Vui lòng nhập đầy đủ địa chỉ VAT !");
      close();
      return;
    }

    if (
      (!dataSubmit.name || dataSubmit.name.length === 0) &&
      String(form.getValues().type) === "4"
    ) {
      close();
      return;
    }

    const dataApi = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblDmCustomer/edit",
      {
        ...dataSubmit,
        listInfoCustomers:
          isType1 && isType4
            ? JSON.stringify(dataSubmit.listInfoCustomers)
            : JSON.stringify([]),
        listInfoAddress:
          isType1 && isType4
            ? JSON.stringify(dataSubmit.listInfoAddress)
            : JSON.stringify([]),
        active: true,
        name:
          isType1 && isType4
            ? dataSubmit.listInfoCustomers?.[0]?.name
            : dataSubmit.name,
        email:
          isType1 && isType4
            ? // ? dataSubmit.listInfoCustomers?.[0]?.attribute1 // vì attribute 1 là biến lưu email của mỗi người mua hàng khi kh là doanh nghiệp
              dataSubmit.email //biến này sẽ lưu email nhận giá trị gia tăng khi khách hàng là doanh nghiệp (chỉnh sửa logic mới thêm email giá trị gia tăng)
            : dataSubmit.email,
        sex:
          isType1 && isType4
            ? dataSubmit.listInfoCustomers?.[0]?.sex
            : dataSubmit.sex,
        birthOfDate:
          isType1 && isType4
            ? dataSubmit.listInfoCustomers?.[0]?.birthOfDate
            : dataSubmit.birthOfDate,
        telephoneNumber:
          isType1 && isType4
            ? // ? dataSubmit.listInfoCustomers?.[0]?.telephoneNumber
              dataSubmit.telephoneNumber //biến này sẽ lưu sđt nhận giá trị gia tăng khi khách hàng là doanh nghiệp (chỉnh sửa logic mới thêm sđt công ty)
            : dataSubmit.telephoneNumber,
        address:
          isType1 && isType4
            ? dataSubmit.listInfoAddress?.[0]?.address
            : dataSubmit.address,
        attribute11:
          isType1 && isType4
            ? JSON.stringify(
                dataSubmit.listInfoAddress?.map((item: any) => ({
                  stt: item.stt,
                  province: item.province,
                  commune: item.commune,
                  address: item.address,
                  attribute1: item.attribute1,
                  attribute2: item.attribute2,
                  attribute3: item.attribute3,
                })),
              )
            : JSON.stringify({
                stt: 1,
                province:
                  dataSubmit.attribute13 && dataSubmit.attribute13 !== ""
                    ? String(dataSubmit.attribute13)
                    : null,
                commune:
                  dataSubmit.attribute14 && dataSubmit.attribute14 !== ""
                    ? String(dataSubmit.attribute14)
                    : null,
                address:
                  dataSubmit.address && dataSubmit.address !== ""
                    ? String(dataSubmit.address)
                    : null,
                attribute1: null,
                attribute2: null,
                attribute3: null,
              }),
        attribute13:
          isType1 && isType4
            ? dataSubmit.listInfoAddress?.[0]?.province
            : dataSubmit.attribute13,
        attribute14:
          isType1 && isType4
            ? dataSubmit.listInfoAddress?.[0]?.commune
            : dataSubmit.attribute14,
        attribute15:
          isType1 && isType4
            ? [
                form.getValues()?.listInfoAddress[0]?.address,
                nameCommune,
                getValueById(
                  String(form.getValues()?.listInfoAddress[0]?.province ?? ""),
                  dataTblProvince,
                  "label",
                ) || "",
              ]
                .filter((i: any) => i && String(i).length > 0)
                .join(", ")
            : [
                form.getValues()?.address,
                listInfoAddressText.communeName,
                listInfoAddressText.provinceName,
              ]
                .filter((i) => i && String(i).length > 0)
                .join(", "),
        attribute16:
          String(dataSubmit.type) === "1" || String(dataSubmit.type) === "4"
            ? null
            : addressCurrentVAT,
      },
    );
    if (dataApi?.success) {
      // Khi mở từ màn bán hàng: set lại địa chỉ KH vừa cập nhật để không bật lại modal
      if (setCustomerCheck) {
        const newAddress =
          isType1 && isType4
            ? dataSubmit.listInfoAddress?.[0]?.address
            : dataSubmit.address;
        const newProvince =
          isType1 && isType4
            ? dataSubmit.listInfoAddress?.[0]?.province
            : dataSubmit.attribute13;
        const newCommune =
          isType1 && isType4
            ? dataSubmit.listInfoAddress?.[0]?.commune
            : dataSubmit.attribute14;

        setCustomerCheck((prev: any) => ({
          ...prev,
          address: newAddress ?? prev?.address,
          attribute13: newProvince ? Number(newProvince) : prev?.attribute13,
          attribute14: newCommune ? Number(newCommune) : prev?.attribute14,
        }));
      }
      modals.closeAll();
      await onClose();
      NotificationExtension.Success("Cập nhật thành công !");
    }
    close();
  };

  //hàm dùng để kiểm tra và thêm người mua hàng có validate
  const handleAddCustomer = (type: number) => {
    if (type === 1) {
      const hasCustomerErrors = Object.keys(form.validate().errors).some(
        (key) => {
          const regex = /^listInfoCustomers\.\d+\.(name|telephoneNumber)$/;
          return regex.test(key);
        },
      );
      if (hasCustomerErrors) {
        return;
      } else {
        form.insertListItem("listInfoCustomers", {
          name: null,
          sex: null,
          birthOfDate: null,
          telephoneNumber: null,
          stt: form.values.listInfoCustomers.length + 1,
          attribute1: null,
          attribute2: null,
          attribute3: null,
        });
        setTimeout(() => {
          nextCustomer(1, form.getValues().listInfoCustomers.length); // Chuyển đến người mới nhất
        }, 0);
      }
    } else if (type === 2) {
      const hasAddressErrors = Object.keys(form.validate().errors).some(
        (key) => {
          const regex =
            /^listInfoAddress\.\d+\.(province|district|commune|address)$/;
          return regex.test(key);
        },
      );
      if (hasAddressErrors) {
        return;
      } else {
        form.insertListItem("listInfoAddress", {
          province: null,
          district: null,
          commune: null,
          address: null,
          stt: form.values.listInfoAddress.length + 1,
          attribute1: null,
          attribute2: null,
          attribute3: null,
        });
        setTimeout(() => {
          nextCustomer(2, form.getValues().listInfoAddress.length); // Chuyển đến địa chỉ mới nhất
        }, 0);
      }
    }
  };

  //lấy thông tin mã số thuế
  useEffect(() => {
    const callApiMaSoThue = async () => {
      try {
        const response = await axios.get(
          `https://hoadondientu.gdt.gov.vn/api/category/public/dsdkts/${form.getValues().taxCode}/manager`,
          {
            headers: {
              "request-id": newGuid(),
            },
          },
        );
        if (response && response.data) {
          const data = response.data;
          const dataAddress = [
            data?.dctsdchi,
            data?.dctsxaten,
            data?.dctstinhten,
          ]
            .filter((i) => i && String(i).length > 0)
            .map((i) => String(i).trim())
            .join(", ");

          let isAdressOld = false;
          if (String(dataAddress).toLowerCase().includes("quận")) {
            isAdressOld = true;
            setTimeout(() => {
              NotificationExtension.Info(
                "Địa chỉ khách hàng của MST trên đang là địa chỉ trước sát nhập vui lòng nhập thông tin địa chỉ sau sát nhập !",
              );
            }, 0);
          }

          const dataCurrentAddress = data?.dctsdchi || "";
          const provinceName = String(data?.dctstinhten || "")
            .toLowerCase()
            .replace("tp", "")
            .replace("thành phố", "")
            .trim();
          const communeName = String(data?.dctsxaten || "")
            .toLowerCase()
            .replace("phường", "")
            .trim();
          const foundProvinceId = dataTblProvince.find((i) =>
            i.label.toLowerCase().includes(provinceName),
          )?.value;

          let foundCommune: any = null;
          if (foundProvinceId) {
            foundCommune = await dataCommuneSelect(
              foundProvinceId,
              communeName,
            );
          }

          setAddressCurrentVAT(!isAdressOld ? dataAddress : "");

          form.setValues((prev: any) => {
            const currentList = Array.isArray(prev.listInfoAddress)
              ? prev.listInfoAddress
              : [];
            const firstItem = currentList[0] || {};
            const newFirstItem =
              (firstItem?.province && String(firstItem?.province).length > 0) ||
              (firstItem?.commune && String(firstItem?.commune).length > 0)
                ? firstItem
                : {
                    ...firstItem,
                    province: dataTblProvince.find((i) =>
                      i.label.toLowerCase().includes(provinceName),
                    )?.value,
                    commune: foundCommune?.value || "",
                    address: dataCurrentAddress,
                  };
            const newList = [newFirstItem, ...currentList.slice(1)];

            return {
              ...prev,
              companyName: data.name || data.ten,
              address: !isAdressOld && data?.dctsdchi,
              attribute13:
                !isAdressOld &&
                dataTblProvince.find((i) =>
                  i.label.toLowerCase().includes(provinceName),
                )?.value,
              attribute14: (!isAdressOld && foundCommune?.value) || "",
              attribute15: !isAdressOld && dataAddress,
              listInfoAddress: !isAdressOld
                ? newList
                : [
                    {
                      stt: 1,
                      province: null,
                      district: null,
                      commune: null,
                      address: null,
                      attribute1: null,
                      attribute2: null,
                      attribute3: null,
                    },
                  ],
            };
          });
        } else {
          NotificationExtension.Info("Không tìm thấy thông tin của MST !");
        }
      } catch (error) {
        console.error("error", error);
      }
    };

    if (isCallFirst) {
      const timeOutId = setTimeout(() => {
        const currentTaxCode = form.getValues().taxCode;

        if (currentTaxCode && String(currentTaxCode).length >= 8) {
          callApiMaSoThue();
        }
      }, 500);

      return () => clearTimeout(timeOutId);
    }
  }, [form.getValues().taxCode]);

  useEffect(() => {
    async function callApi() {
      await Promise.all([callApiGetData()]);
    }
    if (id) callApi();
  }, [id]);

  useEffect(() => {
    const lisInfoAddress = form.getValues().listInfoAddress;
    const currentProvince =
      String(form.getValues()?.type) === "1" ||
      String(form.getValues()?.type) === "4"
        ? form.getValues()?.attribute13
        : lisInfoAddress?.[currentIndexKHDC]?.province;

    if (currentProvince) {
      dataCommuneSelect(currentProvince);
    } else {
      setDataTblCommune([]);
    }
  }, [
    currentIndexKHDC,
    form.getValues().attribute13,
    form.getValues().listInfoAddress?.[currentIndexKHDC]?.province,
  ]);

  useEffect(() => {
    const check = window.location.pathname.includes("customer-list-no-debt");
    setIsChangeDebt(!check);
  }, []);

  useEffect(() => {
    if (
      form.getValues()?.listInfoAddress &&
      Array.isArray(form.getValues()?.listInfoAddress) &&
      String(form.getValues()?.type) !== "1" &&
      String(form.getValues()?.type) !== "4"
    ) {
      const listInfoAddress = form.getValues()?.listInfoAddress;

      setListInfoAddressText({
        provinceName:
          listInfoAddress[currentIndexKHDC]?.province &&
          listInfoAddress[currentIndexKHDC]?.province?.length > 0
            ? getValueById(
                listInfoAddress[currentIndexKHDC]?.province,
                dataTblProvince,
                "label",
              )
            : "",
        communeName:
          listInfoAddress[currentIndexKHDC]?.commune &&
          listInfoAddress[currentIndexKHDC]?.commune?.length > 0
            ? getValueById(
                listInfoAddress[currentIndexKHDC]?.commune,
                dataTblCommune,
                "label",
              )
            : "",
      });
    } else if (
      String(form.getValues()?.type) === "1" ||
      String(form.getValues()?.type) === "4"
    ) {
      const infoAddress = form.getValues();

      setListInfoAddressText({
        provinceName:
          infoAddress?.attribute13 && infoAddress?.attribute13?.length > 0
            ? getValueById(infoAddress?.attribute13, dataTblProvince, "label")
            : "",
        communeName:
          infoAddress?.attribute14 && infoAddress?.attribute14?.length > 0
            ? getValueById(infoAddress?.attribute14, dataTblCommune, "label")
            : "",
      });
    }
  }, [
    form.getValues()?.listInfoAddress,
    form.getValues()?.attribute13,
    form.getValues()?.attribute14,
    dataTblCommune,
    currentIndexKHDC,
  ]);

  useEffect(() => {
    if (
      currentIndexKHDC == 0 &&
      String(form.getValues()?.type) !== "1" &&
      String(form.getValues()?.type) !== "4"
    ) {
      setNameCommune(
        getValueById(
          String(form.getValues()?.listInfoAddress[0]?.commune),
          dataTblCommune,
          "label",
        ),
      );
    }
  }, [form.getValues()?.listInfoAddress, currentIndexKHDC]);

  return (
    <Box
      component="form"
      mx="auto"
      w={{
        base: "400px",
        xs: "500px",
        sm: "700px",
        md: "850px",
        lg: "900px",
      }}
      onSubmit={form.onSubmit((e: any) => {
        handleEditTblDMCustomer(e);
      })}
      style={{ position: "relative" }}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />

      <Grid mt={10}>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <Grid>
            <Grid.Col span={6}>
              <Select
                label={"Loại KH"}
                placeholder={"Chọn loại KH"}
                readOnly
                variant="filled"
                data={
                  isCreateBySeller || !isChangeDebt
                    ? [
                        {
                          value: "1",
                          label: "Cá nhân",
                        },
                        {
                          value: "2",
                          label: "Doanh nghiệp",
                        },
                      ]
                    : [
                        {
                          value: "1",
                          label: "Cá nhân",
                        },
                        {
                          value: "2",
                          label: "Doanh nghiệp",
                        },
                        {
                          value: "3",
                          label: "Doanh nghiệp được cấp hạn mức",
                        },
                        {
                          value: "4",
                          label: "Nhân viên HACOM",
                        },
                      ]
                }
                allowDeselect={false}
                value={form.getValues()?.type?.toString() ?? null}
                {...form.getInputProps("type")}
                onChange={(value) => {
                  form.setValues((prev) => ({
                    ...prev,
                    type: value?.toString(),
                    groupId: value?.toString() === "2" ? "142" : null,
                  }));
                }}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              {form.getValues().type?.toString() === "3" ||
              form.getValues().type?.toString() === "4" ? (
                <TextInput
                  label="Đối tượng công nợ"
                  variant="filled"
                  readOnly
                  value={form.getValues()?.code}
                />
              ) : (
                <Tooltip
                  label={
                    getItemFromData(
                      dataTblDebtGroup,
                      form.getValues().attribute1,
                    )?.label || "Vui lòng chọn đối tượng công nợ"
                  }
                >
                  <Select
                    label={"Đối tượng công nợ"}
                    placeholder={"Chọn đối tượng công nợ"}
                    searchable
                    clearable
                    withAsterisk
                    value={form.getValues().attribute1?.toString() ?? null}
                    data={dataTblDebtGroup}
                    key={form.key("attribute1")}
                    {...form.getInputProps("attribute1")}
                    onSearchChange={(value) => {
                      setKeySearchDebt(value);
                    }}
                    onClick={() => {
                      if (
                        dataTblDebtGroup.length === 0 ||
                        form.getValues().attribute1 === undefined
                      ) {
                        fetchDataDebt();
                      }
                    }}
                    variant={
                      form.getValues().type?.toString() === "3" ||
                      form.getValues().type?.toString() === "4"
                        ? "filled"
                        : "default"
                    }
                    readOnly={
                      form.getValues().type?.toString() === "3" ||
                      form.getValues().type?.toString() === "4"
                    }
                    onChange={(value) => {
                      form.setValues((prev) => ({
                        ...prev,
                        attribute1: value?.toString(),
                      }));
                      // nếu là loại 3 thì set mã khách hàng = đối tượng công nợ
                      if (form.getValues().type?.toString() === "3") {
                        form.setValues((prev) => ({
                          ...prev,
                          code: value?.toString(),
                        }));
                      }
                      //nếu mà loại 1,2 thì chọn đối tượng công nợ xong sẽ fill giá trị vào thời hạn công nợ và hạn mức công nợ
                      const result = dataDebt.filter(
                        (item) => item.groupCode === value?.toString(),
                      );
                      if (result) {
                        form.setValues((prev: any) => ({
                          ...prev,
                          attribute2: result[0]?.debtTerm ?? "", //thời hạn công nợ
                          debtLimit: result[0]?.debtLimit ?? "", //hạn mức công nợ
                        }));
                      }
                    }}
                  />
                </Tooltip>
              )}
            </Grid.Col>
          </Grid>
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <Grid>
            <Grid.Col span={6}>
              <TextInput
                label={"MSKH"}
                type="text"
                variant="filled"
                readOnly
                key={form.key("code")}
                {...form.getInputProps("code")}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <Select
                label={"Nhóm khách hàng"}
                placeholder={"Chọn nhóm khách hàng"}
                withAsterisk={form.getValues().type?.toString() !== "2"}
                searchable
                clearable
                disabled={form.getValues().type?.toString() === "2"}
                value={form.getValues().groupId?.toString() ?? null}
                data={
                  String(form.getValues()?.type) === "4"
                    ? dataTblCustomerGroup.filter(
                        (value: any) => value?.att1 === "3",
                      )
                    : dataTblCustomerGroup.filter(
                        (value: any) =>
                          value?.att1 === form?.getValues().type?.toString(),
                      )
                }
                {...form.getInputProps("groupId")}
                onChange={(value) => {
                  form.setValues((prev) => ({
                    ...prev,
                    groupId: value?.toString(),
                  }));
                }}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>

        <Grid.Col span={12} py={0}>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    label={"Tên doanh nghiệp"}
                    placeholder={"Nhập tên doanh nghiệp"}
                    type="text"
                    withAsterisk={
                      form.getValues().type?.toString() !== "1" &&
                      form.getValues().type?.toString() !== "4"
                    }
                    disabled={form.getValues().type?.toString() === "1"}
                    {...form.getInputProps("companyName")}
                  />
                </Grid.Col>
                {form.getValues().type?.toString() !== "1" &&
                  form.getValues().type?.toString() !== "4" && (
                    <>
                      <Grid.Col span={{ base: 6, md: 6, lg: 6 }}>
                        <TextInput
                          label={"Email nhận giá trị gia tăng"}
                          placeholder={"Nhập email nhận giá trị gia tăng"}
                          type="email"
                          {...form.getInputProps("email")}
                        />
                      </Grid.Col>
                      <Grid.Col span={{ base: 6, md: 6, lg: 6 }}>
                        <TextInput
                          label={"Số điện thoại công ty"}
                          placeholder={"Nhập số điện thoại công ty"}
                          type="text"
                          {...form.getInputProps("telephoneNumber")}
                        />
                      </Grid.Col>
                    </>
                  )}
                <Grid.Col span={{ base: 6, md: 6, lg: 6 }}>
                  <TextInput
                    label={"Mã số thuế"}
                    placeholder={"Nhập mã số thuế"}
                    type="text"
                    withAsterisk={
                      form.getValues().type?.toString() !== "1" &&
                      form.getValues().type?.toString() !== "4" &&
                      form.getValues().groupId?.toString() !== "204"
                    }
                    disabled={form.getValues().type?.toString() === "1"}
                    key={"taxCode"}
                    {...form.getInputProps("taxCode")}
                    onChange={(e) => {
                      form.setFieldValue("taxCode", e.target.value);
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 6, md: 6, lg: 6 }}>
                  <Select
                    label={"Nhóm khách hàng giảm giá"}
                    placeholder={"Chọn nhóm khách hàng giảm giá"}
                    value={form.getValues()?.attribute10}
                    data={[
                      { label: "Nhóm 1", value: "N1" },
                      { label: "Nhóm 2", value: "N2" },
                      { label: "Nhóm 3", value: "N3" },
                    ]}
                    {...form.getInputProps("attribute10")}
                    onChange={(e) => {
                      form.setFieldValue("attribute10", e ? e : "");
                    }}
                  />
                </Grid.Col>
              </Grid>

              {form.getValues().type?.toString() !== "1" &&
              form.getValues().type?.toString() !== "4" ? (
                <>
                  <Fieldset legend={`Người mua hàng`}>
                    <Flex
                      direction={"row"}
                      align={"center"}
                      justify={"space-between"}
                      gap={"md"}
                    >
                      <Box></Box>
                      <Flex
                        direction={"row"}
                        align={"center"}
                        gap={"md"}
                        pl={10}
                      >
                        <Tooltip label={"Sau"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => prevCustomer(1)}
                            disabled={currentIndexKH === 0}
                            size={"sm"}
                          >
                            <IconCaretLeft stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                        <Box>
                          <Text
                            size="md"
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            Người mua {currentIndexKH + 1}
                          </Text>
                        </Box>
                        <Tooltip label={"Trước"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => nextCustomer(1)}
                            disabled={
                              currentIndexKH ===
                              form.getValues().listInfoCustomers.length - 1
                            }
                            size={"sm"}
                          >
                            <IconCaretRight stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                      </Flex>
                      <Box>
                        <Tooltip label={"Thêm người"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => {
                              handleAddCustomer(1);
                            }}
                            size={"sm"}
                          >
                            <IconCirclePlus stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                      </Box>
                    </Flex>

                    <Stack>
                      {form.getValues()?.listInfoCustomers?.length > 0 && (
                        <Box>
                          <Grid key={currentIndexKH}>
                            <Grid.Col span={12}>
                              <TextInput
                                label={"Họ và tên"}
                                placeholder={"Nhập họ và tên"}
                                type="text"
                                withAsterisk
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.name`,
                                )}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <Select
                                label={"Giới tính"}
                                placeholder={"Chọn giới tính"}
                                type="text"
                                clearable
                                data={[
                                  {
                                    value: "1",
                                    label: "Nam",
                                  },
                                  {
                                    value: "2",
                                    label: "Nữ",
                                  },
                                  {
                                    value: "3",
                                    label: "Khác",
                                  },
                                ]}
                                value={
                                  form.getValues()?.listInfoCustomers?.[
                                    currentIndexKH
                                  ]?.sex ?? null
                                }
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.sex`,
                                )}
                                onChange={(value) => {
                                  form.setFieldValue(
                                    `listInfoCustomers.${currentIndexKH}.sex`,
                                    value || null, // Nếu không có giá trị, đặt là null
                                  );
                                }}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <DateInput
                                label="Ngày sinh nhật"
                                placeholder="Chọn ngày sinh nhật"
                                locale="vi"
                                clearable
                                maxDate={new Date()}
                                valueFormat="DD-MM-YYYY"
                                dateParser={(input) => {
                                  const [day, month, year] = input
                                    .split("-")
                                    .map(Number);
                                  return new Date(
                                    Date.UTC(year, month - 1, day),
                                  ); // Tạo Date ở UTC
                                }}
                                value={
                                  form.getValues()?.listInfoCustomers[
                                    currentIndexKH
                                  ]?.birthOfDate
                                    ? new Date(
                                        form.getValues()?.listInfoCustomers[
                                          currentIndexKH
                                        ]?.birthOfDate,
                                      )
                                    : undefined
                                }
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.birthOfDate`,
                                )}
                                onChange={(value) => {
                                  if (value) {
                                    // Lưu giá trị ISO với thời gian ở UTC
                                    const utcDate = new Date(
                                      Date.UTC(
                                        value.getFullYear(),
                                        value.getMonth(),
                                        value.getDate(),
                                      ),
                                    );
                                    form.setFieldValue(
                                      `listInfoCustomers.${currentIndexKH}.birthOfDate`,
                                      utcDate.toISOString(),
                                    );
                                  } else {
                                    form.setFieldValue(
                                      `listInfoCustomers.${currentIndexKH}.birthOfDate`,
                                      undefined,
                                    );
                                  }
                                }}
                              />
                            </Grid.Col>

                            <Grid.Col span={12}>
                              <TextInput
                                label={"Số điện thoại"}
                                placeholder={"Nhập số điện thoại"}
                                type="number"
                                withAsterisk
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.telephoneNumber`,
                                )}
                              />
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <TextInput
                                label={"Email"}
                                placeholder={"Nhập email"}
                                type="text"
                                {...form.getInputProps(
                                  `listInfoCustomers.${currentIndexKH}.attribute1`,
                                )}
                              />
                            </Grid.Col>
                          </Grid>
                        </Box>
                      )}
                    </Stack>
                  </Fieldset>
                </>
              ) : (
                <>
                  <Fieldset legend="Người mua hàng">
                    <Grid>
                      {form.getValues().type?.toString() === "4" ? (
                        <Grid.Col span={12}>
                          <Select
                            label="Họ và tên nhân viên HACOM"
                            placeholder="Nhập mã hoặc tên nhân viên HACOM"
                            data={dataEmployeeHacom.map((i) => ({
                              label: `${i.code} - ${i.fullname}`,
                              value: String(i.code),
                            }))}
                            value={
                              form.getValues().name
                                ? form.getValues().name.split("-")[0].trim()
                                : null
                            }
                            searchable
                            clearable
                            nothingFoundMessage="Không tìm thấy dữ liệu !"
                            withAsterisk
                            onChange={(e) => {
                              const dataSelect = dataEmployeeHacom.find(
                                (i) => String(i.code) === String(e),
                              );

                              form.setValues((prev) => ({
                                ...prev,
                                name: `${e} - ${dataSelect?.fullname}`,
                                sex:
                                  String(dataSelect?.gender) === "0"
                                    ? "1"
                                    : String(dataSelect?.gender) === "1"
                                      ? "2"
                                      : null,
                                birthOfDate: new Date(
                                  new Date(dataSelect?.dateOfBirth).getTime() +
                                    7 * 3600 * 1000,
                                ).toISOString(),
                                telephoneNumber: dataSelect?.phoneNumber,
                                email: dataSelect?.email,
                              }));
                            }}
                            error={
                              form.getValues().type === "4" &&
                              (!form.getValues().name ||
                                String(form.getValues().name).length === 0)
                            }
                          />
                        </Grid.Col>
                      ) : (
                        <Grid.Col span={12}>
                          <TextInput
                            label={"Họ và tên"}
                            placeholder={"Nhập họ và tên"}
                            type="text"
                            withAsterisk
                            {...form.getInputProps("name")}
                          />
                        </Grid.Col>
                      )}

                      <Grid.Col span={12}>
                        <Select
                          label={"Giới tính"}
                          placeholder={"Chọn giới tính"}
                          type="text"
                          clearable
                          data={[
                            {
                              value: "1",
                              label: "Nam",
                            },
                            {
                              value: "2",
                              label: "Nữ",
                            },
                            {
                              value: "3",
                              label: "Khác",
                            },
                          ]}
                          value={form?.getValues()?.sex?.toString() ?? null}
                          key={"sex"}
                          {...form.getInputProps("sex")}
                          onChange={(value) => {
                            form.setValues((prev) => ({
                              ...prev,
                              sex: Number(value),
                            }));
                          }}
                        />
                      </Grid.Col>
                      <Grid.Col span={12}>
                        <DateInput
                          label={"Ngày sinh nhật"}
                          placeholder={"Chọn ngày sinh nhật"}
                          locale="vi"
                          clearable
                          maxDate={new Date()}
                          valueFormat="DD-MM-YYYY"
                          dateParser={(input) => {
                            const [day, month, year] = input
                              .split("-")
                              .map(Number);
                            return new Date(year, month - 1, day);
                          }}
                          value={
                            form.getValues().birthOfDate
                              ? new Date(
                                  form.getValues().birthOfDate?.toString(),
                                )
                              : undefined
                          }
                          key={"birthOfDate"}
                          {...form.getInputProps("birthOfDate")}
                          onChange={(value) => {
                            form.setValues((prev) => ({
                              ...prev,
                              birthOfDate: value?.toISOString(),
                            }));
                          }}
                        />
                      </Grid.Col>

                      <Grid.Col span={12}>
                        <TextInput
                          label={"Số điện thoại"}
                          placeholder={"Nhập số điện thoại"}
                          type="number"
                          withAsterisk
                          key={"telephoneNumber"}
                          {...form.getInputProps("telephoneNumber")}
                        />
                      </Grid.Col>
                    </Grid>
                  </Fieldset>
                </>
              )}

              <Grid>
                {(String(form.getValues().type) === "1" ||
                  String(form.getValues().type) === "4") && (
                  <>
                    <Grid.Col span={12}>
                      <TextInput
                        label={"Email"}
                        placeholder={"Nhập email"}
                        type="text"
                        {...form.getInputProps("email")}
                      />
                    </Grid.Col>
                  </>
                )}
              </Grid>
            </Grid.Col>

            <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
              <Fieldset legend="Công nợ" mt={"md"}>
                <Grid>
                  <Grid.Col span={{ base: 12, md: 6 }}>
                    <NumberInput
                      disabled
                      label={"Thời hạn công nợ (ngày)"}
                      placeholder={"Nhập thời hạn công nợ"}
                      hideControls
                      value={Number(form.getValues()?.attribute2)}
                      key={form.key("attribute2")}
                      {...form.getInputProps("attribute2")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6 }}>
                    <NumberInput
                      disabled
                      label={"Hạn mức công nợ"}
                      placeholder={"Nhập hạn mức công nợ"}
                      thousandSeparator=","
                      hideControls
                      value={Number(form.getValues()?.debtLimit)}
                      key={form.key("debtLimit")}
                      {...form.getInputProps("debtLimit")}
                    />
                  </Grid.Col>
                </Grid>
              </Fieldset>

              {String(form.getValues().type) !== "1" &&
              String(form.getValues().type) !== "4" ? (
                <>
                  <Fieldset mt="7px" legend="Địa chỉ">
                    <Flex
                      direction={"row"}
                      align={"center"}
                      justify={"space-between"}
                      gap={"md"}
                    >
                      <Box></Box>
                      <Flex
                        direction={"row"}
                        align={"center"}
                        gap={"md"}
                        pl={10}
                      >
                        <Tooltip label={"Sau"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => prevCustomer(2)}
                            disabled={currentIndexKHDC === 0}
                            size={"sm"}
                          >
                            <IconCaretLeft stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                        <Box>
                          <Text
                            size="md"
                            style={{
                              fontWeight: "bold",
                            }}
                          >
                            {`Địa chỉ giao hàng ${currentIndexKHDC + 1}`}
                          </Text>
                        </Box>
                        <Tooltip label={"Trước"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => nextCustomer(2)}
                            disabled={
                              currentIndexKHDC ===
                              form.getValues().listInfoAddress.length - 1
                            }
                            size={"sm"}
                          >
                            <IconCaretRight stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                      </Flex>
                      <Box>
                        <Tooltip label={"Thêm địa chỉ"}>
                          <ActionIcon
                            variant="light"
                            onClick={() => {
                              handleAddCustomer(2);
                            }}
                            size={"sm"}
                          >
                            <IconCirclePlus stroke={2} />
                          </ActionIcon>
                        </Tooltip>
                      </Box>
                    </Flex>
                    <Stack>
                      {form.getValues()?.listInfoAddress?.length > 0 && (
                        <Box>
                          <Grid key={currentIndexKHDC}>
                            <Grid.Col span={{ base: 12 }}>
                              <Select
                                label={"Tỉnh/Thành phố"}
                                placeholder={"Chọn Tỉnh/Thành phố"}
                                searchable
                                clearable
                                withAsterisk
                                value={
                                  form.getValues()?.listInfoAddress?.[
                                    currentIndexKHDC
                                  ]?.province ?? null
                                }
                                data={dataTblProvince}
                                onClick={async () => {
                                  if (dataTblProvince.length === 0) {
                                    await dataProvinceSelect();
                                  }
                                }}
                                {...form.getInputProps(
                                  `listInfoAddress.${currentIndexKHDC}.province`,
                                )}
                                onChange={(value) => {
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.province`,
                                    value?.toString(),
                                  );
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.commune`,
                                    null,
                                  );
                                }}
                              />
                            </Grid.Col>
                          </Grid>
                          <Grid>
                            <Grid.Col span={{ base: 12 }}>
                              <Select
                                label={"Phường/Xã"}
                                placeholder={"Nhập Phường/Xã"}
                                searchable
                                clearable
                                withAsterisk
                                disabled={dataTblCommune?.length === 0}
                                data={dataTblCommune}
                                value={
                                  form.getValues()?.listInfoAddress?.[
                                    currentIndexKHDC
                                  ]?.commune ?? null
                                }
                                {...form.getInputProps(
                                  `listInfoAddress.${currentIndexKHDC}.commune`,
                                )}
                                onChange={(value) => {
                                  form.setFieldValue(
                                    `listInfoAddress.${currentIndexKHDC}.commune`,
                                    value?.toString(),
                                  );
                                }}
                              />
                            </Grid.Col>
                          </Grid>
                          <Grid>
                            <Grid.Col span={{ base: 12 }}>
                              <TextInput
                                key={form.key(
                                  `listInfoAddress.${currentIndexKHDC}.address`,
                                )}
                                label={
                                  "Địa chỉ cụ thể (Không bao gồm tên tỉnh/TP, phường/xã)"
                                }
                                h={"100%"}
                                withAsterisk
                                placeholder={"Nhập địa chỉ cụ thể"}
                                {...form.getInputProps(
                                  `listInfoAddress.${currentIndexKHDC}.address`,
                                )}
                              />
                            </Grid.Col>
                          </Grid>
                          {listInfoAddressText.provinceName.length > 0 ||
                          form.getValues()?.listInfoAddress[currentIndexKHDC]
                            ?.address?.length > 0 ? (
                            <Grid>
                              <Grid.Col span={12}>
                                <Text fw={500} size="11.5px">
                                  Địa chỉ:{" "}
                                  {[
                                    form.getValues()?.listInfoAddress[
                                      currentIndexKHDC
                                    ]?.address,
                                    listInfoAddressText.communeName,
                                    listInfoAddressText.provinceName,
                                  ]
                                    .filter(
                                      (i: any) => i && String(i).length > 0,
                                    )
                                    .join(", ")}
                                </Text>
                              </Grid.Col>
                            </Grid>
                          ) : (
                            <></>
                          )}
                        </Box>
                      )}{" "}
                    </Stack>
                    <Divider />
                    <Grid mt={10}>
                      <Grid.Col span={12}>
                        <TextInput
                          label="Địa chỉ VAT"
                          placeholder="Địa chỉ VAT"
                          value={addressCurrentVAT}
                          withAsterisk
                          onChange={(e) =>
                            setAddressCurrentVAT(e.currentTarget.value)
                          }
                        />
                      </Grid.Col>
                    </Grid>
                  </Fieldset>
                </>
              ) : (
                <>
                  <Fieldset mt="7px" legend="Địa chỉ">
                    <Grid>
                      <Grid.Col span={{ base: 12 }}>
                        <Select
                          label={"Tỉnh/Thành phố"}
                          placeholder={"Chọn Tỉnh/Thành phố"}
                          searchable
                          clearable
                          withAsterisk
                          data={dataTblProvince}
                          onClick={async () => {
                            if (dataTblProvince.length === 0) {
                              await dataProvinceSelect();
                            }
                          }}
                          value={
                            form?.getValues()?.attribute13?.toString() || null
                          }
                          {...form.getInputProps("attribute13")}
                          onChange={(value) => {
                            form.setValues((prev) => ({
                              ...prev,
                              attribute14: null,
                              attribute13: value?.toString(),
                            }));
                          }}
                        />
                      </Grid.Col>
                      <Grid.Col span={{ base: 12 }}>
                        <Select
                          label={"Phường/Xã"}
                          placeholder={"Nhập Phường/Xã"}
                          searchable
                          clearable
                          withAsterisk
                          disabled={dataTblCommune?.length === 0}
                          data={dataTblCommune}
                          value={
                            form?.getValues()?.attribute14?.toString() || null
                          }
                          {...form.getInputProps("attribute14")}
                          onChange={(value) => {
                            form.setValues((prev) => ({
                              ...prev,
                              attribute14: value?.toString(),
                            }));
                          }}
                        />
                      </Grid.Col>
                      <Grid.Col span={{ base: 12 }}>
                        <TextInput
                          label={
                            "Địa chỉ cụ thể (Không bao gồm tên tỉnh/TP, phường/xã)"
                          }
                          h={"100%"}
                          withAsterisk
                          placeholder={"Nhập địa chỉ cụ thể"}
                          {...form.getInputProps("address")}
                        />
                      </Grid.Col>
                      {listInfoAddressText.provinceName.length > 0 ||
                      (form.getValues()?.address &&
                        form.getValues()?.address?.length > 0) ? (
                        <Grid>
                          <Grid.Col span={12}>
                            <Text fw={500} size="11.5px">
                              Địa chỉ:{" "}
                              {[
                                form.getValues()?.address,
                                listInfoAddressText.communeName,
                                listInfoAddressText.provinceName,
                              ]
                                .filter((i: any) => i && String(i).length > 0)
                                .join(", ")}
                            </Text>
                          </Grid.Col>
                        </Grid>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  </Fieldset>
                </>
              )}
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>

      <Group
        justify="end"
        mt="xs"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Flex align={"center"} gap={"md"}>
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Flex>
      </Group>
    </Box>
  );
};

export default EditDataView;

type EditDataViewProps = {
  id: string | number;
  onClose: any;
  isCreateBySeller: boolean;
  // Optional: dùng khi mở từ màn bán hàng để set lại địa chỉ KH vừa cập nhật
  setCustomerCheck?: any;
};
